<template>
  <div id="navbar-others-menu-v2" class="others-bottom-sheet-menu btn-group">
    <button id="others-bottom-sheet-menu-toggle-btn" class="btn" @click="toggleBottomSheet">
      <font-awesome-icon
          class="ellipsis"
          :icon="['fas', 'ellipsis-v']"
        />
    </button>
    <s-bottom-sheet
      :value="showBottomSheet"
      @input="$emit('update:showBottomSheet', $event)"
      show-toggler
      click-to-close
      :max-height="bottomSheetMaxHeight">
      <div class="bottom-sheet-item-list">
        <button
          v-if="isTanyamu"
          id="bottom-sheet-item-tanyamu"
          class="bottom-sheet-item bottom-sheet-item-tanyamu inter-medium_small-normal"
          @click.prevent="showTanyamuKelas">
          Tanyamu
        </button>
        <button
          v-if="hasProgramStudyGroupActivity"
          id="bottom-sheet-item-kelompok-belajar-kelas"
          class="bottom-sheet-item bottom-sheet-item-kelompok-belajar-kelas inter-medium_small-normal"
          href="#"
          @click.prevent="showProgramGroupActivityModal(), $emit('logEventAnalytic', 'kelompok_click')"
        >
          Kelompok Belajar Program
        </button>
        <button
          v-if="isTanyamu || isMobile"
          id="bottom-sheet-item-bagikan-aktivitas"
          class="bottom-sheet-item bottom-sheet-item-bagikan-aktivitas inter-medium_small-normal"
          @click="showShareModal"
        >
          Bagikan Aktivitas
        </button>
        <button
          id="explore-halaman-belajar-bottom-sheet-menu"
          class="bottom-sheet-item bottom-sheet-item-explorasi-halaman-belajar inter-medium_small-normal"
          @click="showTour"
        >
          Eksplorasi Halaman Belajar
        </button>
        <button
          id="bottom-sheet-item-panduan"
          class="bottom-sheet-item bottom-sheet-item-panduan inter-medium_small-normal"
          href="https://www.karier.mu/faq/"
          target="_blank"
          @click.prevent="$emit('logEventAnalytic', 'halaman_belajar_panduan_click')"
        >
          Panduan
        </button>
      </div>
    </s-bottom-sheet>
  </div>
</template>
<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import activityV2GeneralMixin from '@/mixins/activityV2/general'
import activityV2TourMixin from '@/mixins/activityV2/tour'

export default {
  name: 'OthersBottomSheetMenu',
  mixins: [activityV2GeneralMixin, activityV2TourMixin],
  props: {
    isTanyamu: {
      type: Boolean,
      default: false
    },
    isMobile: {
      type: Boolean,
      default: false
    },
    facilRoomId: {
      type: Number,
      default: 0
    },
    isTanyamuClosed: {
      type: Boolean,
      default: false
    }
  },
  components: {
    FontAwesomeIcon
  },
  data () {
    return {
      showBottomSheet: false
    }
  },
  computed: {
    hasProgramStudyGroupActivity () {
      return this.$store.state.activityV2.validate.has_program_study_group_activity
    },
    bottomSheetMaxHeight () {
      // Get height from inspector
      const togglerHeight = 38
      const itemHeight = 46
      const paddingBottom = 16

      let bottomSheetItemCount = 3
      if (this.isTanyamu) bottomSheetItemCount++
      if (this.hasProgramStudyGroupActivity) bottomSheetItemCount++

      const maxHeight = togglerHeight + (bottomSheetItemCount * itemHeight) + paddingBottom
      return `${maxHeight}px`
    }
  },
  methods: {
    showShareModal () {
      this.showBottomSheet = false
      this.$emit('showShareModal')
    },
    showTanyamuKelas () {
      this.showBottomSheet = false
      this.$emit('toggleChatBox')
    },
    logEventAnalytic (event) {
      this.$emit('logEventAnalytic', event)
    },
    showProgramGroupActivityModal () {
      this.showBottomSheet = false
      this.$store.commit('activityV2/TOGGLE_PROGRAM_GROUP_ACTIVITY_MODAL', true)
    },
    showTour () {
      this.showBottomSheet = false
      this.initTour()
    },
    toggleBottomSheet () {
      this.showBottomSheet = !this.showBottomSheet
    }
  },
  watch: {
    isTourFinished: {
      immediate: true,
      handler (value) {
        if (value) {
          this.showBottomSheet = false
        }
      }
    }
  }
}
</script>

<style scoped>
.bottom-sheet-item-list {
  display: flex;
  flex-direction: column;
}
.bottom-sheet-item {
  padding: 12px 0 12px 30px;
  text-align: start;
  background-color: inherit;
  background-repeat: no-repeat;
  background-size: 20px 20px;
  background-position: left;
  border: none;
}
.bottom-sheet-item:not(:last-child) {
  border-bottom: 1px solid var(--color-neutral-500);
}
.bottom-sheet-item-tanyamu {
  background-image: url('https://cdn.karier.mu/assets/v2/icon-activity-kariermu/icon-tanyamu-kariermu.svg');
}
.bottom-sheet-item-kelompok-belajar-kelas {
  background-image: url('https://cdn.karier.mu/assets/v2/icon-activity-kariermu/icon-kelompok-belajar-program-kariermu.svg');
}
.bottom-sheet-item-bagikan-aktivitas {
  background-image: url('https://cdn.karier.mu/assets/v2/icon-activity-kariermu/icon-bagikan-kariermu.svg');
}
.bottom-sheet-item-explorasi-halaman-belajar {
  background-image: url('https://cdn.karier.mu/assets/kariermu/v2/navbar/halaman-belajar/eksplorasi.webp');
}
.bottom-sheet-item-panduan {
  background-image: url('https://cdn.karier.mu/assets/v2/icon-activity-kariermu/icon-panduan-kariermu.svg');
}
.ellipsis {
  color: var(--color-royal-navy-500);
  font-size: 18px;
}
</style>
